// Normalize a club's `links` array entries. Older docs store links as plain
// strings; newer docs store them as { url, name, is_members_only } objects.
// This helper keeps legacy records readable while preserving display names.
export function normalizeLink(entry) {
  if (typeof entry === "string") {
    return { url: entry, name: "", is_members_only: false };
  }
  if (entry && typeof entry === "object") {
    return {
      url: entry.url || "",
      name: entry.name || entry.label || entry.title || "",
      is_members_only: !!entry.is_members_only,
    };
  }
  return { url: "", name: "", is_members_only: false };
}

export function normalizeLinks(links) {
  if (!Array.isArray(links)) return [];
  return links.map(normalizeLink);
}

export function canViewLink(link, { isMember, isAdmin }) {
  const normalized = normalizeLink(link);
  return !normalized.is_members_only || isMember || isAdmin;
}
